import React from "react";
import { observer } from "mobx-react";
import classNames from "classnames";
import QuickPlayEventLiveTime from "./QuickPlayEventLiveTime";
import { QuickPlayEventStartTime } from "./QuickPlayEventStartTime";
import { EventOffer } from "@gp/offer";

export default observer(function QuickPlayEventResultAndTime(props: {
	startTime: string | null;
	event: EventOffer | null | undefined;
	isTextInline?: boolean;
}) {
	const detailsWrapperClasses = classNames("card--bbp__details", {
		"card--bbp--nowrap__details": props.isTextInline,
	});

	if (props.event && props.event?.liveStatus && props.event.result) {
		return (
			<div className={detailsWrapperClasses}>
				<QuickPlayEventLiveTime
					event={props.event}
					// isTextInline={props.isTextInline}
				/>
			</div>
		);
	} else if (props.startTime) {
		return (
			<div className={detailsWrapperClasses}>
				<QuickPlayEventStartTime
					startTime={props.startTime}
					isTextInline={props.isTextInline}
				/>
			</div>
		);
	}
	return null;
});
